import LogUtilisateursServices from "@/app/services/admin/LogUtilisateursStudents.services";
import UserService from "@/app/services/admin/UserStudentApi.service";

let today = new Date();
let ip = "";

let paysLocalisation = "";

let villelocalisation = "";
let latitude = "";
let longitude = "";
let firstName = "";
let lastName = "";



const getUserDados = async(userID) => {

  const getDonneeUser = await UserService.userStudentGetcodeIDSeulement(userID, "pesquisaUserID-IDseulement");

  firstName = getDonneeUser.data.firstname;
  lastName = getDonneeUser.data.lastname;
 
}

export async function  deconnectionEtudiantApi(userID, salleDeliberatio, toutLeSystemn) {
  
  const userEnLignesalleDeliberation = {
    enligne: toutLeSystemn,
    enlignesalledeliberation: salleDeliberatio,
    date: new Date(),
    heureconnexionsalledeliberation:
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds(),
    datedeconnexionsalledeliberation: new Date(),
    tipo: "deconnexion du logiciel",
    userID
  };

  await UserService.updateStudent(userID, userEnLignesalleDeliberation);

  
  return "ok";
}

export async function logUtilisateurs(userID, formulaire, evenement) {
//   console.log("logUtilisateurs called with:", { userID, formulaire, evenement });

  try {
    await getUserDados(userID);

    const userDados = {
      data: today,
      hora: today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds(),
      formulario: formulaire,
      evento: evenement,
      userID: userID,
      firstname: firstName,
      lastname: lastName,
      adressip: ip,
      paysLocalisation: paysLocalisation,
      villelocalisation: villelocalisation,
      latitude: latitude,
      longitude: longitude
    };

    // console.log("Creating log with userDados:", userDados);

    await LogUtilisateursServices.create(userDados);

    // console.log("Log created successfully");
    return "ok";
  } catch (error) {
   //  console.error("Error during logUtilisateurs:", error);
    throw error; // Ensure the error is propagated
  }
}